<div>
  <ngb-alert [dismissible]="false" type="warning">
    <div class="redirect-message">
      {{ 'redirect.message' | translate }}
      <div>support@nordicenergyaudit.se</div>
    </div>
  </ngb-alert>
</div>